import {useEffect, useState} from 'react';

import {articleMapper} from '../../mappers/comments/article-mapper';
import {createArticle} from '../../models/article';
import {readArticle} from '../../use-cases/comments/read-article';
import {isNil} from '../helpers';

import {useArticleFromMemory} from './useArticleFromStore';

const useArticleModel = articleId => {
  const $articleBlock = document.querySelector(`.js-article[data-id="${articleId}"]`);

  const articleModel = createArticle({
    url: $articleBlock.dataset.url,
    id: articleId,
    headline: $articleBlock.dataset.title,
    isCommentsEnabled: Boolean($articleBlock.dataset.isCommentsEnabled)
  });

  const articleFromMemory = useArticleFromMemory(articleId);

  const [article, setArticle] = useState(articleMapper.toDomain(articleModel, 0, ''));

  useEffect(() => {
    if (articleFromMemory && !articleFromMemory.id) {
      readArticle(articleId);
    }
  }, [articleFromMemory]);

  useEffect(() => {
    if (!isNil(articleFromMemory)) {
      const joinedArticleData = {
        ...article,
        commentsCount: articleFromMemory.commentCount || 0,
        createdAt: articleFromMemory.lastCommentDate || ''
      };

      setArticle(joinedArticleData);
    }
  }, [articleFromMemory]);

  return article;
};

export {useArticleModel};
